<template>
    <div class="nogo-wrapper">
        <div class="nogo-info">
            <div class="title">
                <p>No-Go's</p>
            </div>
            <div class="info">
                <p>Tag keywords that specify absolute No-Go's for bookings.</p>
            </div>
        </div>
        <div class="nogo-fields">
            <input
                v-model="keywordInput"
                :class="tagInput.error ? 'input-err' : ''"
                @input="handleValidateKeywordInput(tagInput)"
                @keyup.enter="handleAddTag(tagInput.error)"
                type="text"
                maxlength="25"
                name="nogo"
                placeholder="Add more tags here"
            />
            <div v-if="tagInput.error" class="err-msg">
                <img :src="URLS.icons.error" alt="err-icon" />
                <p>
                    {{ tagInput.errorMessage }}
                </p>
            </div>
            <div v-if="keywords.length" class="nogo-tags">
                <p class="labl">No-Go's is:</p>
                <div v-for="(tag, indx) in keywords" :key="indx" class="tag-wrapper">
                    <span @click="handleDeleteTag(indx)" class="tag">{{ tag }}</span>
                </div>
            </div>
            <div v-if="renderSuggestedKeywords.length" class="suggested-tags">
                <p class="title">Suggested tags:</p>
                <div
                    v-for="(tag, indx) in renderSuggestedKeywords"
                    :key="indx"
                    class="tag-wrapper"
                >
                    <span
                        class="tag"
                        :class="{ 'selected-tag': tag.selected }"
                        @click="handleSelectTag(tag)"
                    >
                        {{ tag.name }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const suggestedTags = [
        {
            name: 'No Covers',
            selected: false
        },
        {
            name: 'No amplified sound',
            selected: false
        },
        {
            name: 'No bands larger than 3 people',
            selected: false
        },

        {
            name: 'No under 21',
            selected: false
        }
    ]

    import useKeywords from '@/composables/useKeywords.js'
    const URLS = {
        icons: {
            error: '/images/error.svg'
        }
    }
    export default {
        name: 'NogoSection',
        emits: ['nogo-changed', 'nogo-err', 'update:nogos'],
        props: {
            nogos: {
                type: String,
                required: false,
                default: ''
            },
            clearNogos: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        setup() {
            const {
                keywordInput,
                suggestedKeywords,
                renderSuggestedKeywords,
                keywords,
                validateKeywordInput,
                handleAddTag,
                handleSelectTag,
                handleDeleteTag,
                populateKeywords,
                clearKeywords
            } = useKeywords(suggestedTags)

            return {
                keywordInput,
                suggestedKeywords,
                renderSuggestedKeywords,
                keywords,
                validateKeywordInput,
                handleAddTag,
                handleSelectTag,
                handleDeleteTag,
                populateKeywords,
                clearKeywords
            }
        },
        data: () => ({
            tagInput: {
                nogo: '',
                error: false,
                errorMessage: 'Please eter tags with alphanumeric characters.'
            }
        }),
        computed: {
            URLS: () => URLS
        },
        watch: {
            nogos: {
                immediate: true,
                handler(nogos) {
                    this.populateKeywords(nogos)
                }
            },
            clearNogos: function (clear) {
                if (clear) {
                    this.handleClearKeywords()
                }
            },
            keywords: function (keywords) {
                this.$emit('nogo-changed', keywords)
            },
            keywordInput: function (keyword) {
                this.nogo = keyword
            }
        },
        methods: {
            handleClearKeywords() {
                this.clearKeywords()
                this.$emit('update:clearNogos', false)
                this.$emit('update:nogos', '')
            },
            handleValidateKeywordInput(tagInput) {
                this.validateKeywordInput(tagInput)
                this.$emit('nogo-err', tagInput.error)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .nogo-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 40px;

        .input-err {
            border: 1px solid #e23453 !important;
        }
        .err-msg {
            display: flex;
            flex-direction: row;
            gap: 10px;

            p {
                margin-bottom: 0px;
                color: #e23453;
                font-family: Instrument Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
                letter-spacing: -0.16px;
            }
        }
        .nogo-info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;

            .title {
                p {
                    margin-bottom: 0px;
                    color: #f5f5f5;
                    font-size: 32px;
                    font-family: Instrument Sans;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 120%;
                    letter-spacing: -0.64px;
                }
            }

            .info {
                p {
                    color: #acacac;
                    font-size: 16px;
                    font-family: Instrument Sans;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 125%;
                    margin-bottom: 0px;
                }
            }
        }

        .nogo-fields {
            display: flex;
            flex-direction: column;
            gap: 24px;

            .nogo-tags,
            .suggested-tags {
                display: flex;
                flex-direction: row;
                gap: 20px 10px;
                flex-wrap: wrap;
                max-width: 1047px;

                .title {
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                    margin-top: 0px !important;
                    margin-bottom: 0px !important;
                }
            }

            span {
                cursor: pointer;
                padding: 7px min(28px, 10px) 9px min(30px, 10px);
                border-radius: 100px;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 650;
                line-height: 125%;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #8b8b8b;
                text-wrap: nowrap;
            }

            .suggested-tags {
                min-height: 80px;
                margin-top: 26px;
            }
            .nogo-tags {
                p {
                    margin-bottom: 0px;
                    color: #dedede;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                }
                span {
                    cursor: pointer;
                    padding: 7px min(28px, 10px) 9px min(30px, 10px);
                    border-radius: 100px;
                    border: 1px solid #e0939c;
                    background: #262626 url(/images/icons/delete-pink.svg) no-repeat 96% 50%;
                    background-size: 8px 8px;
                    color: #e0939c;
                    font-family: Instrument Sans;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 125%;
                }
            }

            input {
                max-width: 603px;
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1.5px solid #8b8b8b;
                background: #262626;
                color: #f5f5f5;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 650;
                line-height: 125%;
            }

            input::placeholder {
                color: #646464;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 650;
                line-height: 125%;
            }
        }
    }
</style>
